// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rFl2gEBoNfE7B9m1VgOs{display:flex;font-size:14px}.en4EQj_Y8AEp9H2XZK9j{margin-right:10px;width:15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `rFl2gEBoNfE7B9m1VgOs`,
	"iconWrapper": `en4EQj_Y8AEp9H2XZK9j`
};
module.exports = ___CSS_LOADER_EXPORT___;
